import { Component } from '@angular/core';
import Plyr from 'plyr';
import { PlyrModule } from '@atom-platform/ngx-plyr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-video-player',
  standalone: true,
  imports: [PlyrModule],
  templateUrl: './video-player.component.html',
  styleUrl: './video-player.component.css'
})
export class VideoPlayerComponent {

  videoLink = 'https://player.vimeo.com/video/995705083?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
  poster = 'assets/dummy_thumbnail.png';
  data = {
    status: 'success',
    message: 'Video Fetching successful',
    code: 200,
    data: {
      video_detail: {
        id: 4,
        video_id: 15,
        profile_id: 143,
        action_type: 'student',
        video_duration: '120',
        end_second: '5',
        watch_percentage: '4.17',
        watch_count: '0',
        playback_duration: '13',
        playback_count: '65',
        is_completed: false,
        created_by: 143,
        updated_by: 143,
        created_at: '2025-07-10T14:09:39.000000Z',
        updated_at: '2025-07-30T13:59:58.000000Z',
        video_title: 'Testing video21',
        video_link: '994692990#t=5',
        thumbnail: 'http://localhost:8000/',
        video_lock: 'lock',
        is_reel_link: true,
        theory: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        theory_lock: 'show',
        no_of_views: '10',
        views_lock: 'show',
        price: '100',
        thumbnail_lock: 'lock'
      },
      is_video_like: false,
      is_video_dislike: true,
      like_count: 1,
      dislike_count: 1,
      playback_time: '13', // can skip backward to specified time
      playback_limit: '9', // number of times video can be backwatched
      is_playback: true, // check if backwatching is allowed
      is_video_view: false // check if video is viewed
    }
  }

  player!: Plyr;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      const videoLink = params.get('videoLink');
      const thumbnail = params.get('thumbnail');
      const title = params.get('title');

      if (videoLink) {
        this.videoLink = this.getVimeoSource(videoLink);
        this.videoSources = this.buildVideoSources(this.videoLink);
      }

      if (thumbnail) {
        this.poster = thumbnail;
        this.plyrOptions = {
          ...this.plyrOptions,
          previewThumbnails: { enabled: false, src: thumbnail }
        };
      }

      if (title) {
        this.data.data.video_detail.video_title = title;
        this.plyrOptions = {
          ...this.plyrOptions,
          mediaMetadata: { title, artist: 'ME' }
        };
      }
    });
  }

  videoSources: Plyr.Source[] = this.buildVideoSources(this.videoLink);

  plyrOptions: Plyr.Options = {
    fullscreen: { enabled: true, fallback: true, iosNative: true, allowAudio: true },
    settings: ['captions', 'quality', 'speed', 'loop'],
    loadSprite: true,
    seekTime: 20,
    clickToPlay: true,
    hideControls: false,
    speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 4] },
    quality: {
      default: 1080,
      options: [1080, 720, 480],
    },
    loop: { active: false },
    vimeo: { byline: false, portrait: false, title: false, speed: true, transparent: false },
    previewThumbnails: { enabled: false, src: this.poster },
    mediaMetadata: { title: this.data.data.video_detail.video_title, artist: 'ME' }
  };





  played(event: Plyr.PlyrEvent) {
    console.log('played', event);
  }

  play(): void {
    this.player.play();
  }

  private buildVideoSources(videoLink: string): Plyr.Source[] {
    return [
      {
        src: videoLink,
        provider: 'vimeo',
        size: 1080,
        type: 'video/vimeo',
      },
    ];
  }

  private getVimeoSource(videoLink: string): string {
    if (/^https?:\/\//i.test(videoLink)) {
      return videoLink;
    }

    return `https://vimeo.com/${videoLink}`;
  }

  paused(event: Plyr.PlyrEvent) {
    console.log('paused', event);
  }

  ended(event: Plyr.PlyrEvent) {
    console.log('ended', event);
  }

  seeked(event: Plyr.PlyrEvent) {
    console.log('seeked', event);
  }

  timeUpdate(event: Plyr.PlyrEvent) {
    console.log('timeUpdate', event);
  }

}
